import React from "react";
import "./ToolButton.css";

function ToolButton({
  icon,
  title,
  onClick,
  active = false,
}) {
  return (
    <button
      type="button"
      className={`tool-button ${active ? "active" : ""}`}
      title={title}
      onClick={onClick}
    >
      {icon}
    </button>
  );
}

export default ToolButton;